/* Homepage community reel rail, 17/10/2026 (Justyn: "The UGC slider on mobile is really scatty... smooth that up").
   Moved out of hr-home.js and rebuilt so a swipe is the phone's own scroll from start to finish:
   - every tile keeps one fixed size in the layout, so the snap points never move while a finger is down. The centred
     clip is shown bigger with a transform (scale + slide), which the browser animates without re-laying out the page
   - on scroll only scrollLeft is read (tile positions are measured once, and again on resize); nothing per frame
   - the endless loop (the set is tripled) only jumps back to the middle copy once the swipe has fully stopped and no
     finger is down, so it never cuts a fling short
   - only the centred clip gets a video; posters load for it and its neighbours once the reel is near the screen.
   The full screen player (hr-reels.js, with the sound button) builds on this. */
(function () {
  'use strict';
  if (window.__hrUgc) return;
  window.__hrUgc = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function setup(rail) {
    if (rail.__hrUgc) return;
    rail.__hrUgc = true;
    var root = rail.closest('[data-hr]') || rail.parentNode;
    var base = $$('.ugc__item', rail), n = base.length;
    if (!n) return;
    base.forEach(function (el) { var c = el.cloneNode(true); c.dataset.clone = '1'; c.removeAttribute('data-shopify-editor-block'); rail.appendChild(c); });
    base.slice().reverse().forEach(function (el) { var c = el.cloneNode(true); c.dataset.clone = '1'; c.removeAttribute('data-shopify-editor-block'); rail.insertBefore(c, rail.firstElementChild); });
    var items = $$('.ugc__item', rail), dots = $$('.ugc__dots button', root);
    var prev = $('[data-hr-prev]', root), next = $('[data-hr-next]', root);
    var qEl = $('[data-hr-ugc-q]', root), byEl = $('[data-hr-ugc-by]', root), fig = $('[data-hr-ugc-quote]', root);
    var start = Math.max(0, Math.min(n - 1, parseInt(rail.dataset.start || '0', 10) || 0));
    var cur = -1, target = null, near = false, touching = false, dragging = false, touched = false, idleT = 0, raf = 0;

    /* ---------- geometry, measured once (tiles never change size in the layout) ---------- */
    var c0 = 0, pitch = 1, half = 0;
    var measure = function () {
      c0 = items[0].offsetLeft + items[0].offsetWidth / 2;
      pitch = (items[1] ? items[1].offsetLeft - items[0].offsetLeft : items[0].offsetWidth) || 1;
      half = rail.clientWidth / 2;
    };
    /* exact layout centre of clip k (transforms do not move offsetLeft), so a glide ends right on the clip */
    var leftFor = function (k) { var el = items[k]; return el ? el.offsetLeft + el.offsetWidth / 2 - half : c0 + k * pitch - half; };
    var nearest = function () { return Math.max(0, Math.min(items.length - 1, Math.round((rail.scrollLeft + half - c0) / pitch))); };

    /* ---------- video: only the centred clip plays; posters for it and its neighbours ----------
       17/10 (Justyn, iPhone: "started playing multiple videos and not the right video for the right sound"): only the
       centred clip keeps a video loaded. A clip that leaves the centre is stopped, muted and unloaded (its poster shows),
       because iPhones only cope with a few loaded videos at once and the reel used to keep every clip it passed */
    var unload = function (v) {
      if (!v.paused) v.pause();
      v.muted = true;
      if (v.getAttribute('src')) { v.removeAttribute('src'); v.load(); }
    };
    var syncVideos = function (k) {
      if (!near) return;
      items.forEach(function (el, i) {
        var v = el.__v || (el.__v = $('video', el));
        if (!v) return;
        var d = Math.abs(i - k);
        if (d <= 2 && v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster);
        if (i === k) {
          if (!v.getAttribute('src') && v.dataset.src) { v.preload = 'auto'; v.src = v.dataset.src; }
          if (v.getAttribute('src') && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else unload(v);
      });
    };
    /* and anything in the reel that starts playing while it is not the centred clip is stopped and silenced at once */
    rail.addEventListener('play', function (e) {
      var v = e.target;
      if (v.tagName !== 'VIDEO' || cur < 0) return;
      if (v !== (items[cur].__v || $('video', items[cur]))) { v.pause(); v.muted = true; }
    }, true);
    /* hr-reels.js asks before moving on by itself when a clip ends: not while a finger is on the reel or it is moving */
    var lastScroll = 0;
    rail.__hrBusy = function () { return touching || dragging || Date.now() - lastScroll < 400; };

    /* ---------- the centred clip ---------- */
    var setActive = function (k) {
      if (k === cur) return;
      cur = k;
      items.forEach(function (el, i) {
        var o = i - k;
        el.classList.toggle('is-active', o === 0);
        /* how far (in "size differences") a side tile slides towards the middle so the gaps stay even; tiles more than
           four away are off screen, so their value stays the same and the browser has nothing to redo for them */
        var a = Math.min(Math.abs(o), 5);
        var fk = o === 0 ? '0' : String(-(o > 0 ? 1 : -1) * (a - 0.5));
        if (el.__fk !== fk) { el.__fk = fk; el.style.setProperty('--fk', fk); }
      });
      syncVideos(k);
      var src = items[k];
      if (qEl && fig && src && src.dataset.quote) {
        fig.classList.add('is-out');
        clearTimeout(fig._t);
        fig._t = setTimeout(function () {
          qEl.textContent = '“' + src.dataset.quote + '”';
          byEl.textContent = src.dataset.by || '';
          fig.classList.remove('is-out');
        }, 260);
      }
      var o = ((k % n) + n) % n;
      dots.forEach(function (d, i) { if (i === o) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    };

    /* 19/10 (Justyn: "part of the jumping around is the menu changing"): the quote above the reel is one line for
       some clips and two for others, so every change between them pushed the whole reel up or down ~33px. The quote
       box keeps the height of the longest quote at this width (its words sit at the bottom, by the videos). */
    var sizeQuote = function () {
      if (!fig || !qEl) return;
      var keepQ = qEl.innerHTML, keepB = byEl ? byEl.textContent : '', h = 0;
      fig.style.minHeight = '';
      base.forEach(function (el) {
        if (!el.dataset.quote) return;
        qEl.textContent = '“' + el.dataset.quote.replace(/\*/g, '') + '”';
        if (byEl) byEl.textContent = el.dataset.by || '';
        h = Math.max(h, fig.offsetHeight);
      });
      qEl.innerHTML = keepQ;
      if (byEl) byEl.textContent = keepB;
      if (h) fig.style.minHeight = h + 'px';
    };

    var goTo = function (k, instant) {
      k = Math.max(0, Math.min(items.length - 1, k));
      if (instant) { rail.scrollLeft = leftFor(k); setActive(k); }
      /* 19/10 (Justyn: "the videos shake around a bit too much as it flicks through them ... as the product below
         appears"): with snapping on, the browser aimed the glide at where the next clip sat while it was still
         shrunk, then jumped ~20px once it had grown, right as its product card faded in. Snapping is off while the
         reel glides to the exact centre, and comes back (with nothing left to correct) once it has stopped. */
      else { touched = true; clearTimeout(glideT); rail.classList.add('is-glide'); rail.scrollTo({ left: leftFor(k), behavior: reduce ? 'auto' : 'smooth' }); }
    };

    /* endless: once everything has come to rest, hop to the same clip in the middle copy (no animation, same picture) */
    var stepAt = 0, glideT = 0;
    var wrap = function () {
      if (touching || dragging) return;
      /* 19/10 (Justyn "still doing it between these two", "not smooth"): an arrow step past either end starts with an
         instant hop, and that hop's own scroll event used to run this wrap while the slide was still under way, which
         yanked the reel back a whole copy. Wait until the arrow's slide has reached its clip (or given up). */
      if (target !== null && Math.abs(rail.scrollLeft - leftFor(target)) > 2 && Date.now() - stepAt < 1500) { settle(); return; }
      /* snapping comes back once the clips have finished resizing (0.55s), so it has nothing to nudge */
      clearTimeout(glideT); glideT = setTimeout(function () { rail.classList.remove('is-glide'); }, 650);
      var k = nearest();
      if (k >= n && k < 2 * n) { target = null; return; }
      var t = k < n ? k + n : k - n;
      rail.classList.add('no-anim');
      rail.scrollLeft = leftFor(t) + (rail.scrollLeft - leftFor(k));
      cur = -1; setActive(t);
      void rail.offsetWidth;
      requestAnimationFrame(function () { rail.classList.remove('no-anim'); });
      if (target !== null) { var tt = target + (t - k); target = null; if (tt !== t) goTo(tt); }
    };
    var settle = function () { if (!opened) return; clearTimeout(idleT); idleT = setTimeout(wrap, 'onscrollend' in window ? 60 : 180); };

    rail.addEventListener('scroll', function () {
      if (!opened) return; /* the browser can scroll the rail while the copies are added; it is lined up when it opens */
      lastScroll = Date.now();
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; setActive(nearest()); });
      settle();
    }, { passive: true });
    if ('onscrollend' in window) rail.addEventListener('scrollend', settle, { passive: true });
    rail.addEventListener('touchstart', function () { touching = true; target = null; rail.classList.remove('is-glide'); clearTimeout(idleT); }, { passive: true });
    var lift = function () { touching = false; settle(); };
    rail.addEventListener('touchend', lift, { passive: true });
    rail.addEventListener('touchcancel', lift, { passive: true });

    /* ---------- computers: arrows, dots, click a side clip, drag with the mouse ---------- */
    /* 19/10 (Justyn "switcher is broken back and forward"): stepping off either end of the middle copy left the hop
       back to the middle to the after-scroll wrap, which fired before the step finished, so the click landed on the
       same clip again (back from Compression PRO showed Compression PRO). Now the hop happens first, instantly and
       on an identical picture, and then the reel slides one clip, so every click moves exactly one. */
    var stepTo = function (d) {
      var base = target === null ? cur : target;
      var dest = base + d;
      if (dest < n || dest >= 2 * n) {
        var shift = dest < n ? n : -n;
        clearTimeout(idleT);
        clearTimeout(glideT); rail.classList.add('no-anim', 'is-glide');
        rail.scrollLeft = leftFor(base + shift);
        cur = -1; setActive(base + shift);
        void rail.offsetWidth;
        requestAnimationFrame(function () { rail.classList.remove('no-anim'); });
        dest += shift;
      }
      target = Math.max(1, Math.min(items.length - 2, dest));
      stepAt = Date.now();
      goTo(target);
    };
    if (prev) prev.addEventListener('click', function () { stepTo(-1); });
    if (next) next.addEventListener('click', function () { stepTo(1); });
    /* 19/10 (Justyn: "doesnt do it when you click the arrows but when you click the video itself to go backwards"):
       dots, side clips and drags used to leave the arrows' last target behind, and the wrap then sent the reel to it
       (a whole copy away and back). They clear it now, and a click on a side clip moves like the arrows do. */
    dots.forEach(function (d, i) { d.addEventListener('click', function () {
      target = null;
      goTo([i, i + n, i + 2 * n].sort(function (a, b) { return Math.abs(a - cur) - Math.abs(b - cur); })[0]);
    }); });
    items.forEach(function (el, i) { $('.ugc__tile', el).addEventListener('click', function () { if (i !== cur) { target = null; stepTo(i - cur); } }); });

    var x0 = 0, s0 = 0, moved = 0, dx = 0, dragRaf = 0;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true; target = null; x0 = e.clientX; s0 = rail.scrollLeft; moved = 0; dx = 0;
      rail.classList.add('is-drag');
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dx = e.clientX - x0; moved = Math.max(moved, Math.abs(dx));
      if (!dragRaf) dragRaf = requestAnimationFrame(function () { dragRaf = 0; rail.scrollLeft = s0 - dx; });
    });
    window.addEventListener('pointerup', function () {
      if (!dragging) return;
      dragging = false; rail.classList.remove('is-drag');
      goTo(nearest());
    });
    rail.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
    rail.addEventListener('dragstart', function (e) { e.preventDefault(); });

    var rw = rail.clientWidth;
    window.addEventListener('resize', function () {
      if (rail.clientWidth === rw) return; /* phones fire resize when the address bar hides: nothing to redo */
      rw = rail.clientWidth;
      if (!opened) return; /* not set up yet: it measures itself when it opens */
      var k = cur; measure(); sizeQuote(); cur = -1; goTo(k, true);
    });

    /* ---------- start ----------
       19/10 (speed): the reel is set up once it is about to come on screen, not while the page loads. Measuring it
       made the browser restyle the whole page (about 6,000 elements) three times during load (on start, when the
       fonts arrived and on load), which froze a mid-range phone for over a second while the hero was animating.
       The observer below opens it 400px before it shows, so nothing changes on screen. */
    var opened = false;
    var open = function () { opened = true; rail.classList.add('no-anim'); measure(); sizeQuote(); cur = -1; goTo(n + start, true); void rail.offsetWidth; rail.classList.remove('no-anim'); };
    rail.addEventListener('pointerdown', function () { touched = true; }, { passive: true });
    rail.addEventListener('touchstart', function () { touched = true; }, { passive: true });
    /* fonts or images above can still shift the width before the first swipe (only matters once it is open) */
    window.addEventListener('load', function () { if (opened && !touched) open(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (opened) sizeQuote(); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (!es.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        near = true;
        if (!opened || !touched) open();
        syncVideos(cur);
      }, { rootMargin: '400px 0px' });
      io.observe(rail);
    } else { open(); near = true; syncVideos(cur); }
  }

  function init() { $$('.hr [data-hr-ugc]').forEach(setup); }
  init();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 0); });
})();
